'use client';

import { VStack, StackProps, Show, forwardRef } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';

import { FooterLinks } from './FooterLinks';

const animationVariants = {
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
};

export interface MainProps extends StackProps {
  noFooter?: boolean;
  animation?: 'fade' | 'none';
}

export const Main = forwardRef<MainProps, 'div'>((props, ref) => {
  const { children, noFooter = false, animation = 'fade', ...rest } = props;

  const selectedAnimation =
    animation !== 'none' ? animationVariants[animation] : undefined;

  return (
    <AnimatePresence>
      <VStack
        ref={ref}
        as={animation !== 'none' ? motion.div : undefined}
        initial={selectedAnimation?.initial}
        animate={selectedAnimation?.animate}
        exit={selectedAnimation?.exit}
        bg="white"
        h="full"
        w="full"
        p="1.5rem"
        rounded="lg"
        shadow="0px 0px 20px #0000004D"
        borderBottomRadius={['lg', 'lg', 0]}
        gap="1.875rem"
        color="blue.800"
        {...rest}
      >
        {children}

        {!noFooter && (
          <Show above="md" ssr>
            <FooterLinks mt="auto" />
          </Show>
        )}
      </VStack>
    </AnimatePresence>
  );
});
